module.exports = {"en":{"home.scenarioterre.welcome":"Annotate the « Scénario Terre » website"},"fr":{"home.scenarioterre.welcome":"Annotez le site « Scénario Terre »"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/messages.json
// module id = 117
// module chunks = 0